import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTop from '../../commoncomponents/scrollToTop/scrollToTop';

const Footer = () => {
   return (
      <>
         <footer className="footer-wrapper footer-layout2" data-bg-src="assets/img/bg/footer_bg_1.png">
            <hr className="style1" />
            <div className="widget-area">
               <div className="container">
                  <div className="row justify-content-between">
                     <div className="col-md-6 col-xl-4">
                        <div className="widget footer-widget">
                           <div className="th-widget-about">
                              <div className="about-logo">
                                 <Link to="/">
                                    <img src="/assest/img/logo.png" alt="Vega Studio" />
                                 </Link>
                              </div>
                              <p className="about-text">
                                 Vega Studio offers expert music and dance instruction, providing personalized lessons, studio rentals, and a supportive environment for all
                                 levels.
                              </p>
                           </div>
                        </div>
                     </div>

                     <div className="col-md-6 col-xl-auto">
                        <div className="widget widget_nav_menu footer-widget">
                           <h3 className="widget_title">Quick Links</h3>
                           <div className="menu-all-pages-container">
                              <ul className="menu">
                                 <li>
                                    <Link to="/service-agreement">Service Agreement</Link>
                                 </li>
                                 <li>
                                    <Link to="/reserve-slot">Reserve a Slot</Link>
                                 </li>
                                 <li>
                                    <Link to="/gallery">Gallery</Link>
                                 </li>
                                 <li>
                                    <Link to="/disclaimer">Disclaimer</Link>
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>

                     <div className="col-md-6 col-xl-3">
                        <div className="widget footer-widget">
                           <h3 className="widget_title">Opening Hours</h3>
                           <div className="office-hour th-social-wrapper">
                              <p className="info-box_text">
                                 Monday to Sunday <br />09:00 AM - 09:00 PM
                              </p>
                           </div>
                           <div className="th-social">
                              <h6 className="social-title">Follow Us:</h6>
                              <Link to="https://www.facebook.com/ivegastudio" target="_blank" rel="noreferrer noopener">
                                 <i className="fab fa-facebook-f" />
                              </Link>
                              <Link to="https://www.instagram.com/ivegastudio" target="_blank" rel="noreferrer noopener">
                                 <i className="fab fa-instagram" />
                              </Link>
                              <Link to="https://www.tiktok.com/ivegastudio" target="_blank" rel="noreferrer noopener">
                                 <i className="fab fa-tiktok" />
                              </Link>
                              <Link to="https://www.youtube.com/@ivegastudio" target="_blank" rel="noreferrer noopener">
                                 <i className="fab fa-youtube" />
                              </Link>
                           </div>
                        </div>
                     </div>

                     <div className="col-md-6 col-xl-auto">
                        <div className="widget footer-widget">
                           <h3 className="widget_title">Contact Now</h3>
                           <div className="th-widget-contact">
                              <div className="info-box">
                                 <div className="info-box_icon">
                                    <i className="fa-sharp fa-solid fa-location-dot" />
                                 </div>
                                 <p className="info-box_text">4216, Unit No.2, Street 10, NE, Calgary, AB, T2E 6K3.</p>
                              </div>

                              <div className="info-box">
                                 <div className="info-box_icon">
                                    <i className="fa-solid fa-phone" />
                                 </div>
                                 <p className="info-box_text">
                                    <Link to="tel:+14035758877" className="info-box_link">
                                       +1 (825) 945-1618
                                    </Link>
                                 </p>
                              </div>

                              <div className="info-box">
                                 <div className="info-box_icon">
                                    <i className="fa-solid fa-envelope" />
                                 </div>
                                 <p className="info-box_text">
                                    <Link to="mailto:info@vegastudio.ca" className="info-box_link">
                                       info@vegastudio.ca
                                    </Link>
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="copyright-wrap">
               <div className="container">
                  <div className="row align-items-center">
                     <div className="col-lg-6">
                        <p className="copyright-text">
                           Copyright <i className="fal fa-copyright" /> 2025 Vega Studio. All Rights Reserved.
                        </p>
                     </div>
                     <div className="col-lg-6">
                        <div className="footer-copyright-right style2">
                           <ul>
                              <li>
                                 <Link to="/terms-of-service">Terms of Service</Link>
                              </li>
                              <li>
                                 <Link to="/privacy-policy">Privacy Policy</Link>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </footer>

         <ScrollToTop />
      </>
   );
};

export default Footer;
